module.exports = __webpack_public_path__ + "img/solar-supply-direct.e9e9200a.jpg";